/**
 * Convert a string to PascalCase
 * @param str snake_case or kebab-case string
 * @returns PascalCase string
 */
export const convertToPascalCase = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return str;
  }

  // First convert to camelCase
  const camelCase = str
    .replace(/[-_]([a-z])/g, (_, char) => char.toUpperCase())
    .replace(/^([A-Z])/, (_, char) => char.toLowerCase());

  // Then capitalize the first letter for PascalCase
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
